import { useEffect, useState } from "react";

const Timer = ({ start, duration = 60, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    let timer;

    if (start) {
      setTimeLeft(duration);

      timer = setInterval(() => {
        setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [start, duration]);

  useEffect(() => {
    if (timeLeft === 0 && onComplete) onComplete();
  }, [timeLeft, onComplete]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / duration);
    const secs = seconds % duration;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  return <span>({formatTime(timeLeft)})</span>;
};

export default Timer;
